/* axios config配置 */
import axios from 'axios';
import Qs from 'qs';
import { message } from 'ant-design-vue';
import Common, { isMobilePlatform } from '@/utils/common';
import { APP_ID, APP_SECRET } from '@/utils/constant';
import { logOut } from '@/utils/setup/logOut';

const instance = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  params: {},
  timeout: 1000 * 30,
  headers: {
    'Content-Type': 'application/json'
  },
  paramsSerializer: function (params) {
    return Qs.stringify(params, {arrayFormat: 'brackets'});
  },
  withCredentials: false,
  responseType: 'json',
  maxContentLength: 2000,
  maxRedirects: 5,
  validateStatus: function (status) {
    return status === 200; // 状态码为200时，为成功，否则失败
  }
});

function refreshToken (config) {
  return POST({
    url: '/userLogin/refresh',
    params: {
      refreshToken: config.params.refreshToken,
      userId: config.params.userId,
      grantType: 'refresh_token',
      appId: APP_ID,
      appSecret: APP_SECRET
    }
  });
}

// 请求拦截器
instance.interceptors.request.use(config => {
  if (Common.getToken()) {
    const token = Common.getToken();
    config.headers.Authorization = token.includes('Bearer') ? token : `Bearer ${token}`;
  }

  const PlatFormType = sessionStorage.getItem('PlatFormType');
  if (PlatFormType) { // 0：游览器； 1：app
    config.headers.deviceType = PlatFormType;
    config.headers.PlatFormType = PlatFormType; // 用于区分 app 端和 pc 端的 token
  } else {
    config.headers.deviceType = 0;
  }

  const applyType = sessionStorage.getItem('applyType');
  if (applyType) {
    config.headers.applyType = applyType; // applyype 1社区小程 2工程3管家通小程序
  }

  return config;
}, error => {
  return Promise.reject(error);
}
);

let isReclick = false;
function debounce (fun, time) {
  if (isReclick) {
    return;
  } else {
    isReclick = true;
    setTimeout(function () {
      isReclick = false;
    }, time);
  }
  fun();
}

// 响应拦截器  用于token失效时刷新
let isRefreshing = false;
let requestList = [];
instance.interceptors.response.use((res) => {
  if (res.data.code === 401) {
    if (!isRefreshing) {
      isRefreshing = true;
      axios({
        method: 'post',
        data: {
          refreshToken: localStorage.refreshToken,
          userId: localStorage.userId,
          grantType: 'refresh_token',
          appId: APP_ID,
          appSecret: APP_SECRET
        }
      }).then(newRes => {
        // console.log('401 then: ');
        let data = newRes.data;
        const newToken = data.access_token;
        Common.setToken(newToken);
        localStorage.refreshToken = data.refreshToken;
        res.config.headers.Authorization = 'Bearer ' + newToken;
        requestList.forEach(callback => callback(newToken));
        requestList = [];
        return instance(res.config);
      }).catch(() => {
        // console.log('401 catch: ');
        debounce(() => {
          message.error('登录已失效', 1).then((res) => {
            logOut();
          });
        }, 2000);
      }).finally(() => {
        isRefreshing = false;
      });
    } else {
      return new Promise(resolve => {
        requestList.push(newToken => {
          res.config.headers.Authorization = 'Bearer ' + newToken;
          resolve(instance(res.config));
        });
      });
    }
  } else {
    return res;
  }
}, (error) => {
  return Promise.reject(error);
});

/**
 * 封装请求方法
 * @param options, 配置参数
 * @param obj, 其他参数
 * @returns {Promise<any>}
 */
const fetch = (options, obj) => {
  let { spinObj } = obj;
  let { btnLoading } = obj;
  let { localeText } = obj;
  if (localeText) {
    localeText.emptyText = '加载中...';
  }
  spinObj && (spinObj.spinning = true); // 打开loading
  btnLoading && (btnLoading.loading = true);

  return new Promise((resolve, reject) => {
    instance(options).then((res) => {
      let resData = res.data;
      spinObj && setTimeout(() => { spinObj.spinning = false; }, 300); // 关闭loading
      btnLoading && setTimeout(() => { btnLoading.loading = false; }, 300);
      if (localeText && resData.data) {
        let list = resData.data.list;
        if (!list || !list.length) {
          localeText.emptyText = '暂无数据';
        }
      }
      if (resData.code === 1 || resData.code === 2 || resData.code === 200) { // 1：成功，2：单独处理导入房间部分成功
        resolve(resData); // 注意：resolve只接收一个参数
      } else if (resData.code === 9002) { // accessToken失效
        document.cookie = 'accessToken=';
      } else if (resData.code === 9004) { // 登录的账号被删除（包括其他电脑）后强退
        message.error('当前登录账号已被删除', 1).then((res) => {
          logOut();
        });
      } else if (resData.code === 401) { // 令牌失效
      } else if (resData.code === 403) { // 无权限
        resData.msg && message.error(resData.msg, 5);
      } else if (resData.code === 9003 || resData.code === 30000) { // 登录失效，社区是 40000，account、acsecurity、acadmin是 30000
        debounce(() => {
          message.error(resData.msg, 1).then((res) => {
            logOut();
          });
        }, 2000);
      } else {
        resData.msg && message.error(resData.msg, 5); // 错误提示信息
        reject(res);
      }
    }).catch((err) => {
      spinObj && setTimeout(() => { spinObj.spinning = false; }, 300); // 关闭loading
      btnLoading && setTimeout(() => { btnLoading.loading = false; }, 300);
      if (localeText) {
        localeText.emptyText = '暂无数据';
      }
      let errData = (err.response || {}).data;
      reject(errData);

      if (err.response) {
        /* 错误提示信息 */
        if (errData && errData.msg) {
          message.error(errData.msg, 5);
        } else {
          message.error('网络不给力，请刷新重试');
        }
      } else {
        message.error('网络不给力，请刷新重试');
      }
    });
  });
};

export function GET (obj) {
  let { url, params, config } = obj;
  config = config || {};
  if (this && Object.keys(this).length) {
    config = {...config, ...this};
  }

  return fetch({
    method: 'get',
    url,
    params,
    ...config
  }, obj);
}

export function POST (obj) {
  let { url, params, config, query } = obj;
  config = config || {};
  if (this && Object.keys(this).length) {
    config = {...config, ...this};
  }

  return fetch({
    method: 'post',
    url,
    params: query, // 单独处理文件上传
    data: params, // data 只适用于这些请求方法 'PUT', 'POST', 和 'PATCH'
    ...config
  }, obj);
}

export function DELETE (obj) {
  let { url, params, config } = obj;
  config = config || {};
  if (this && Object.keys(this).length) {
    config = {...config, ...this};
  }

  return fetch({
    method: 'delete',
    url,
    params, // DELETE 参数放在路由 query
    ...config
  }, obj);
}

export function PUT (obj) {
  let { url, params, config } = obj;
  config = config || {};
  if (this && Object.keys(this).length) {
    config = {...config, ...this};
  }

  return fetch({
    method: 'put',
    url,
    data: params, // data 只适用于这些请求方法 'PUT', 'POST', 和 'PATCH'
    ...config
  }, obj);
}

let config = { baseURL: process.env.VUE_APP_BASE_API_LOGIN };
export const _DELETE = DELETE.bind(config);
